import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import OrnamentoDourado from "@/components/OrnamentoDourado";
import SEO from "@/components/SEO";
import { useLang } from "@/lib/i18n";

export default function SobrePage() {
  const { t } = useLang();
  return (
    <div className="mx-auto max-w-3xl px-6 py-12" data-testid="sobre-page">
      <SEO
        title={`${t.sobre} | salmos.pt`}
        description={t.sobre_p1}
      />
      <nav className="flex items-center gap-2 font-display text-[10px] uppercase tracking-[0.22em] text-[var(--cor-texto-2)]">
        <Link to="/" className="hover:text-[var(--cor-dourado-claro)]">{t.inicio}</Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-[var(--cor-dourado)]">{t.sobre}</span>
      </nav>

      <header className="text-center mt-16">
        <div className="font-display text-[10px] uppercase tracking-[0.32em] text-[var(--cor-dourado)]">{t.sobre}</div>
        <h1 className="font-display text-5xl md:text-6xl text-[var(--cor-texto)] mt-4 font-light">{t.sobre_titulo}</h1>
        <OrnamentoDourado className="mt-10" />
      </header>

      <div className="mt-16 font-serif text-[var(--cor-texto)] text-lg leading-[2] space-y-6">
        <p>
          <span className="float-left font-display text-7xl text-[var(--cor-dourado)] leading-[0.85] mr-3 mt-1">{t.sobre_p1.charAt(0)}</span>
          <span>{t.sobre_p1.slice(1)}</span>
        </p>
        <p>{t.sobre_p2}</p>
        <p>{t.sobre_p3}</p>
        <p className="italic text-[var(--cor-texto-2)]">{t.sobre_p4}</p>
      </div>

      <OrnamentoDourado simbolo="❧" className="mt-20" />
    </div>
  );
}
